import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './contact.css';
import TopNavbar from '../components/TopNavbar';
import { contactData } from '../data/portfolioData';

const Contact = () => { 
  const [formStatus, setFormStatus] = useState('Send');

  const onSubmit = (e) => {
    e.preventDefault();
    setFormStatus('Submitting...');

    // Pass the form element directly
    emailjs.sendForm(
      contactData.emailjs.serviceId,
      contactData.emailjs.templateId,
      e.target, // Pass the form element here
      contactData.emailjs.publicKey
    )
    .then(
      (result) => {
        alert('Message sent successfully...');
        console.log(result.text);
        setFormStatus('Send');
      },
      (error) => {
        console.log(error.text);
        setFormStatus('Send');
      }
    );
  }

  return (
    <div>
          <TopNavbar />
    <div className="background-container">

      <div className="container" id="contact">
        <div className="contact-container">
          <div className="container mt-5 contact">
              <h2 style={{textAlign: "center"}} className="section-header">Contact Me</h2>
            <form onSubmit={onSubmit}>
              <div className="mb-3">
                <label className="form-label" htmlFor="name">{contactData.formLabels.name}</label>
                <input className="form-control" type="text" id="name" name="name" required />
              </div>
              <div className="mb-3">
                <label className="form-label" htmlFor="email">{contactData.formLabels.email}</label>
                <input className="form-control" type="email" id="email" name="email" required />
              </div>
              <div className="mb-3">
                <label className="form-label" htmlFor="message">{contactData.formLabels.message}</label>
                <textarea className="form-control" id="message" name="message" required />
              </div>
              <button className="btn btn-success submit-button" type="submit">
                {formStatus}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}

export default Contact;
